import { Link } from "@tanstack/react-router";
import { ArrowLeft, Home } from "lucide-react";
import { Button } from "@/components/ui/button";
import React from "react";

export function NotFound({ children }: { children?: React.ReactNode }) {
  return (
    <div className="w-full flex flex-col items-center justify-center min-h-[50vh] space-y-8 p-8 text-center">
      <div className="space-y-4">
        <div className="text-6xl font-bold text-muted-foreground">404</div>
        <div className="space-y-2">
          <h1 className="text-2xl font-semibold">Page Not Found</h1>
          <div className="text-muted-foreground max-w-md">
            {children || <p>The page you are looking for doesn't exist or has been moved.</p>}
          </div>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row gap-4">
        <Button
          onClick={() => window.history.back()}
          variant="outline"
          className="flex items-center gap-2"
        >
          <ArrowLeft className="h-4 w-4" />
          Go Back
        </Button>
        <Button asChild>
          <Link to="/" className="flex items-center gap-2">
            <Home className="h-4 w-4" />
            Return Home
          </Link>
        </Button>
      </div>
    </div>
  );
}
